export default class Redirect {
  static parseUrl() {
    const authUrl = process.env.REACT_APP_AUTH_URL
    return `${authUrl}/internal/federated/sign-in?redirect=${window.location.href}`
  }

  static navigate(url) {
    const redirectUrl = url || Redirect.parseUrl()
    window.location.assign(redirectUrl)
  }
}
